import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stationName' })
export class StationNamePipe implements PipeTransform {
  transform(pigeonRouteDetails: any, stationId: number) {
    for (const station of pigeonRouteDetails.stations) {
      if (station.stationId === stationId) {
        return station.name;
      }
    }
    return '';
  }
}
